import './App.css';
import React, { useState, useEffect } from 'react';
import ApiContext from './ApiContext';
import VideoGallery from './VideoGallery';

const App = () => {
    const apiUrl = 'https://nt6bocjsnd.execute-api.eu-west-1.amazonaws.com/production';
    const [apiData, setApiData] = useState(null); // Hier speichern Sie die API-Daten

    return (
        <ApiContext.Provider value={{ baseUrl: apiUrl, data: apiData }}>
            <div className="App">
                <header className="App-header">
                    <img className="header-image" src="title.png" />
                    <div className="legal-header">
                        <div>Tauchschule Abyss</div>
                        <div><a href="https://www.tauchbasis-riesenstein.com/leere-seite-2">Datenschutzrichtlinie</a></div>
                        <div><a href="https://www.tauchbasis-riesenstein.com/leere-seite-1">Impressum</a></div>
                    </div>
                </header>
                <main>
                    <VideoGallery />
                </main>
            </div>
        </ApiContext.Provider>
    );
};

export default App;
